import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
export const reactPlugin = new ReactPlugin();
